import { Component, OnInit, Input, Inject } from "@angular/core";
import * as moment from "moment";
import { Router } from "@angular/router";
import { AppService } from "src/app/core/app/app.service";
import { Product } from "src/app/core/product/product.model";
import { DateService } from "src/app/core";
import { DateDetailsPopupComponent } from "..";
import { Pass } from "src/app/core/product/product.factory";
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";

@Component({
  selector: "ll-add-pass-to-date-popup",
  templateUrl: "./add-pass-to-date-popup.component.html",
  styleUrls: ["./add-pass-to-date-popup.component.scss"]
})
export class AddPassToDatePopupComponent implements OnInit {
  public ds: DateService = new DateService();
  canAdd: Product[];

  constructor(
    public router: Router,
    public app: AppService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<DateDetailsPopupComponent>
  ) {}

  get products(): Product[] {
    return this.data.products;
  }
  get events(): Pass[] {
    return this.data.events;
  }
  get date(): string {
    return this.data.date;
  }
  ngOnInit(): void {
    this.canAdd = this.getApplicable();
  }

  get header(): string {
    return "Add a Pass";
  }
  get subheader(): string {
    return moment(this.date.replace("-", "/")).format("MMM DD, YYYY (ddd)");
  }
  get isAdmin(): string {
    return this.router.url.includes("admin") ? "/admin" : "";
  }
  get sectionLabel(): string {
    return "ADD APPLICABLE EXISTING PASS";
  }

  getApplicable(): Product[] {
    var lst = [];
    for (var i = 0; i < this.products.length; i++) {
      var isActive = this.products[i].isActive;
      const isNotAssignedToDate = !this.events.some(
        event => event.product.id == this.products[i].id
      );
      if (isActive && isNotAssignedToDate) {
        lst.push(this.products[i]);
      }
    }
    return lst;
  }

  public back() {
    this.dialogRef.close();
    const options = new MatDialogConfig();
    options.disableClose = false;
    options.autoFocus = true;
    options.hasBackdrop = true;
    options.ariaLabel = "Date Details Popup";
    options.data = {
      events: this.events,
      date: this.date,
      products: this.products
    };
    const dialogRef = this.dialog.open(DateDetailsPopupComponent, options);
    // this.modalRef = this.modalService.show(DateDetailsPopupComponent, {
    //   class: "modal-lg modal-dialog-centered",
    //   containerClass: "",
    //   animated: true,
    //   ignoreBackdropClick: true,
    //   data: {
    //     events: this.events,
    //     date: this.date
    //   }
    // });
  }
  public add(product: Product) {
    this.app.editProductBuilder(product);
    this.app.addCustomDateEventBuilder(
      moment(this.date)
        .tz(this.app.state.venue.cityTimezone, true)
        .toDate()
    );
    this.dialogRef.close();
    this.router.navigateByUrl(`${this.isAdmin}/venue/passes/date-form`);
  }

  public addPass() {
    this.app.addProductBuilder();
    this.dialogRef.close();
    this.router.navigateByUrl(`${this.isAdmin}/venue/passes/pass-form`);
  }
}
